import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import FlexBox from 'components/common/FlexBox/FlexBox'
import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'
import { FONT_WEIGHT } from 'designSystem/foundations/constants/fontWeight'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  hasTaxBudgetSet: boolean
  onClick: () => void
  onClose: () => void
  showModal: boolean
}

export default function ConfirmTaxBudgetPreferencesModal({
  hasTaxBudgetSet,
  onClick,
  onClose,
  showModal,
}: Props) {
  return (
    <Modal isCentered isOpen={showModal} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader />
        <ModalBody>
          <FlexBox flexDirection="column" gap={SIZE.s16}>
            <PDSText
              color={COLOR.textSecondary}
              fontWeight={FONT_WEIGHT.fw600}
              fontSize={FONT_SIZE.md}
            >
              Do you want to save your investment preferences?
            </PDSText>
            {hasTaxBudgetSet ? (
              <PDSText
                color={COLOR.textSecondary}
                fontWeight={FONT_WEIGHT.fw600}
              >
                By saving these preferences, you will establish an target gains
                budget for this portfolio. The gains budget presented is a
                target estimate and may vary based on the specific tax lots
                settled.
              </PDSText>
            ) : (
              <PDSText
                color={COLOR.textSecondary}
                fontWeight={FONT_WEIGHT.fw600}
              >
                By saving these preferences, Pave will attempt to cap the gains
                to approximately 2% of your portfolio value at the time of
                trading. The gains budget presented is a target estimate and may
                vary based on the specific tax lots settled.
              </PDSText>
            )}
            <PDSText color={COLOR.textSecondary} fontWeight={FONT_WEIGHT.fw400}>
              The gains budget may be impacted by unsettled transactions and may
              not reflect final figures until all trades have settled. If there
              are any unsettled trades, additional trading may result in
              exceeding the budget. 
            </PDSText>
            <PDSText color={COLOR.textSecondary} fontWeight={FONT_WEIGHT.fw400}>
              Gains may take up to 31 days to be fully and accurately reflected
              in the system. 
            </PDSText>
          </FlexBox>
        </ModalBody>

        <ModalFooter marginBottom={SIZE.s8}>
          <PDSBox width="100%">
            <PDSBox marginBottom={SIZE.s12}>
              <PDSButton
                text="Save Investment Preferences"
                onClick={onClick}
                size="md-f"
                variant="primary"
              />
            </PDSBox>

            <PDSButton
              text="Cancel"
              onClick={onClose}
              size="md-f"
              variant="tertiary"
            />
          </PDSBox>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
